import { useEffect, useState } from "react";
import { RefreshCw, Sparkles, X } from "lucide-react";
import { registerServiceWorker, promptUpdate } from "@/serviceWorkerRegistration";

// Gold-on-navy "New version available" banner. Registers the SW (production only) and shows
// itself when a newer service worker is ready; one tap "Refresh" activates it and reloads.
export default function PwaUpdateBanner() {
  const [reg, setReg] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    registerServiceWorker({ onUpdate: (r) => { setReg(r); setDismissed(false); } });
  }, []);

  if (!reg || dismissed) return null;

  return (
    <div
      data-testid="pwa-update-banner"
      className="fixed inset-x-0 bottom-0 z-[9999] flex justify-center px-4 pb-4 pointer-events-none"
      style={{ fontFamily: "IBM Plex Sans, sans-serif" }}
    >
      <div className="pointer-events-auto flex items-center gap-3 rounded-xl border border-[#C20511]/40 bg-[#0B1420] px-4 py-3 shadow-2xl ring-1 ring-[#C20511]/20 w-full sm:w-auto sm:min-w-[380px]">
        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full" style={{ background: "rgba(201,154,60,0.15)" }}>
          <Sparkles size={16} style={{ color: "#C20511" }} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-bold text-white leading-tight" style={{ fontFamily: "Manrope, sans-serif" }}>New version available</div>
          <div className="text-[11px] text-slate-400">A newer version of SYMIN is ready.</div>
        </div>
        <button
          data-testid="pwa-update-refresh"
          onClick={() => promptUpdate(reg)}
          className="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-bold text-white transition-transform hover:scale-[1.03]"
          style={{ background: "#C20511" }}
        >
          <RefreshCw size={14} /> Refresh
        </button>
        <button
          data-testid="pwa-update-dismiss"
          onClick={() => setDismissed(true)}
          className="shrink-0 text-slate-500 hover:text-slate-300 transition-colors"
          aria-label="Dismiss"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
